var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgSettings = function SvgSettings(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 18,
    height: 18,
    fill: "none"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M8.03 2.625a1.305 1.305 0 0 0 1.94 0l.63-.692a1.306 1.306 0 0 1 2.273.942l-.047.934a1.305 1.305 0 0 0 1.367 1.369l.934-.047a1.306 1.306 0 0 1 .94 2.273l-.695.627a1.307 1.307 0 0 0 0 1.939l.695.627a1.306 1.306 0 0 1-.942 2.273l-.934-.047a1.305 1.305 0 0 0-1.37 1.37l.047.934a1.306 1.306 0 0 1-2.268.94l-.627-.694a1.306 1.306 0 0 0-1.939 0l-.63.694a1.306 1.306 0 0 1-2.27-.939l.047-.933a1.305 1.305 0 0 0-1.37-1.371l-.934.047a1.305 1.305 0 0 1-.944-2.271l.694-.627a1.307 1.307 0 0 0 0-1.939l-.694-.63a1.305 1.305 0 0 1 .94-2.27l.933.047a1.305 1.305 0 0 0 1.372-1.374l-.045-.934a1.306 1.306 0 0 1 2.271-.94z",
    clipRule: "evenodd"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M9 12a3 3 0 1 0 0-6 3 3 0 0 0 0 6",
    clipRule: "evenodd"
  })));
};
export default SvgSettings;